import Select from "react-select";

import { Icons, theme } from "../../../../assets";
import { TOption } from "../../../../models";
import * as s from "./styled-select-profile-input";

type SelectProjectProfileActivity = {
    value?: TOption;
    profilesOptions: TOption[];
    errorMessage?: string;
    onChange: (...event: any[]) => void;
    disabled?: boolean;
};

function SelectProjectProfileActivity({
    disabled,
    errorMessage,
    onChange,
    profilesOptions,
    value,
}: SelectProjectProfileActivity) {
    const DropdownIndicator = () => {
        return (
            <s.PositionIcons>
                <Icons.Chevron />
            </s.PositionIcons>
        );
    };
    return (
        <s.FlexColumn error={!!errorMessage}>
            <Select
                value={value || null}
                name={"profile_id"}
                onChange={onChange}
                classNamePrefix={"react-select"}
                options={profilesOptions}
                components={{ DropdownIndicator }}
                noOptionsMessage={() => "Sem opções"}
                menuPlacement={"auto"}
                isDisabled={disabled}
                styles={{
                    control: (base) => ({
                        ...base,
                        width: "100%",
                        minHeight: "2.75rem",
                    }),
                    menu: (base) => ({
                        ...base,
                        width: "100%",
                    }),
                    menuList: (base) => ({
                        ...base,
                        maxHeight: "25rem !important",
                    }),
                    groupHeading: (base) => ({
                        ...base,
                        color: theme.gray400,
                        fontSize: "0.875rem",
                        fontWeight: 400,
                        lineHeight: "20px",
                        letterSpacing: "0.0088rem",
                        textTransform: "none",
                        padding: "0rem 1rem",
                        paddingBottom: "0.5rem",
                        width: "100%",
                    }),
                    option: (base, { isSelected }) => ({
                        ...base,
                        "&:hover": {
                            backgroundColor: theme.gray50,
                        },
                        backgroundColor: isSelected ? theme.gray100 : "",
                        color: isSelected ? theme.gray900 : theme.gray600,
                        fontSize: "0.875rem",
                        fontWeight: 400,
                        paddingLeft: "2rem",
                        width: "100%",
                    }),
                    placeholder: (base) => ({
                        ...base,
                        color: theme.gray400,
                        fontSize: "0.875rem",
                        fontWeight: 400,
                    }),
                    input: (base) => ({
                        ...base,
                        color: theme.gray600,
                        fontSize: "1.25rem",
                        fontWeight: 400,
                        width: "100%",
                    }),
                    noOptionsMessage: (base) => ({
                        ...base,
                        color: theme.gray400,
                        fontSize: "0.875rem",
                        fontWeight: 400,
                        textAlign: "left",
                    }),
                    singleValue: (base) => ({
                        ...base,
                        color: theme.gray600,
                        fontSize: "1.25rem",
                        fontWeight: 400,
                    }),
                }}
            />
            {!!errorMessage && <s.Error>{errorMessage}</s.Error>}
        </s.FlexColumn>
    );
}

export default SelectProjectProfileActivity;
